import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';
import AnimationComp from '../animation-comp/AnimationComp.component';
import './DashboardEventItem.styles.css';

const DashboardEventItemMobile = ({isEmpty, data, t}) => {
    if(isEmpty) {
        return(
            <div className='cm-dash-event-item cm-dash-event-empty-item cm-dash-event-empty-item-mob py-12 px-3 col-3 d-flex align-items-center'>
                <div className="cm-empty-dash-event-footer d-flex align-items-center text-blue-gray-700 fw-medium">
                    <FontAwesomeIcon icon={regular('face-smile')} className="text-blue-gray-700" />
                    <p className='text-blue-gray-700 my-0 ms-2'>{t('no_events_available')}</p>
                </div>
                <p className='ps-2 text-blue-500 fw-medium'>{t('nothing_to_see')}</p>
            </div>
        )
    } else {
        return (<div className={`cm-dash-event-item bg-white`}>
                <div className="cm-dash-event-item-footer text-blue-gray-700 d-flex align-items-center cm-sm-txt">
                    <div className={`cm-left-col ${!data.iconClass ? 'd-flex align-items-center' : ''}`}>
                        {data.iconClass ?  <FontAwesomeIcon icon={data.iconClass} className="pe-2" /> : <div className='pe-1'><AnimationComp animationData={data.animation.data} width={data.animation.width} height={data.animation.height} /></div>}
                        <span className="fw-medium cm-sm-txt">{data.subTitle}</span>
                    </div>
                    <p className='my-0 text-blue-500 fw-medium ps-2'>{data.title}</p>
                    {
                        !!data.eventLink ?
                        <>
                            <div className="cm-de-event-hr my-0 bg-blue-gray-300" />
                            <Link to={data.eventLink} className="text-action-blue cm-sm-txt fw-semibold">
                                {t('view_event')}
                                <FontAwesomeIcon icon={regular('angle-right')} className="ps-2" />
                            </Link>
                        </>
                        : null
                    }
                </div>
            </div>)
    }
}


DashboardEventItemMobile.defaultProps = {
    isEmpty: false,
}

export default DashboardEventItemMobile;